import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

/**
 * Parse data keys like "DD-MM-YYYY"
 */
export function parseDataKey(key) {
  if (!key) return null;
  const d = dayjs(key, ["DD-MM-YYYY", "YYYY-MM-DD"], true);
  return d.isValid() ? d : null;
}

/**
 * Parse input values from <input type="date"> (YYYY-MM-DD)
 */
export function parseInputDate(val) {
  if (!val) return null;
  const d = dayjs(val, "YYYY-MM-DD", true);
  return d.isValid() ? d : null;
}

/**
 * Resolve a usable date range for ALL charts
 */
export function resolveDateRange({
  sortedKeys,
  startDateInput,
  endDateInput,
  monthsBack = 3,
}) {
  if (!sortedKeys?.length) return { start: null, end: null };

  const first = parseDataKey(sortedKeys[0]);
  const last = parseDataKey(sortedKeys[sortedKeys.length - 1]);
  if (!first || !last) return { start: null, end: null };

  let start = parseInputDate(startDateInput);
  let end = parseInputDate(endDateInput);

  // start only → until latest
  if (start && !end) {
    end = last;
  }

  // end only → go back N months
  if (!start && end) {
    start = end.subtract(monthsBack, "month");
  }

  // neither → default last N months
  if (!start && !end) {
    end = last;
    start = last.subtract(monthsBack, "month");
  }

  // clamp to dataset bounds
  if (start.isBefore(first)) start = first;
  if (end.isAfter(last)) end = last;

  return { start, end };
}
